var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnapBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 127,
    viewBox: "0 0 467 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.206352,
    filter: "url(#filter0_f_7710_11547)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.9083,
    y: 89.8528,
    width: 69.0568,
    height: 21.1471,
    fill: "#FCDA67"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7710_11547)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 99.1044,
    height: 99.3915,
    rx: 26.3298,
    fill: "#FCDA67"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_7710_11547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4935 56.5533C48.8369 51.9519 48.117 46.4836 49.4922 41.3515C50.8673 36.2193 54.2249 31.8436 58.8263 29.187C63.4277 26.5304 68.8959 25.8104 74.0281 27.1856C79.1603 28.5608 83.536 31.9184 86.1926 36.5197L76.4651 42.1359C75.298 40.1144 73.3756 38.6394 71.121 38.0352C68.8663 37.4311 66.464 37.7474 64.4425 38.9145C62.421 40.0816 60.9459 42.0039 60.3418 44.2586C59.7377 46.5133 60.0539 48.9156 61.221 50.9371L51.4935 56.5533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7752 52.2794C78.4319 56.8808 79.1518 62.3491 77.7766 67.4813C76.4014 72.6134 73.0439 76.9891 68.4425 79.6457C63.8411 82.3024 58.3728 83.0223 53.2406 81.6471C48.1085 80.2719 43.7328 76.9143 41.0762 72.313L50.8037 66.6968C51.9708 68.7183 53.8931 70.1933 56.1478 70.7975C58.4025 71.4016 60.8048 71.0853 62.8263 69.9182C64.8478 68.7511 66.3228 66.8288 66.927 64.5741C67.5311 62.3194 67.2148 59.9171 66.0477 57.8956L75.7752 52.2794Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_7710_11547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.404 75.2683C168.31 75.2683 175.494 69.0048 175.494 60.8292C175.494 50.1482 167.182 47.6428 161.244 46.6538C157.326 45.9945 154.714 45.2033 154.714 42.6979C154.714 40.8518 156.138 39.9287 158.751 39.9287C162.491 39.9287 164.629 41.7089 165.757 43.8847L174.9 38.8079C172.169 32.2147 166.232 28.7203 159.226 28.7203C150.32 28.7203 143.73 34.9838 143.73 43.1594C143.73 53.7745 152.517 56.3458 158.513 57.3348C162.135 57.9282 164.51 58.3238 164.51 60.9611C164.51 63.0709 162.313 64.0599 159.404 64.0599C155.664 64.0599 153.407 62.8072 152.279 60.104L143.136 65.1807C145.867 71.7739 151.804 75.2683 159.404 75.2683Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.815 51.7965C200.734 51.7965 202.218 55.2909 202.218 59.4446V74.2134H212.905V57.9941C212.905 48.3021 207.799 40.2584 196.815 40.2584C185.832 40.2584 180.726 48.3021 180.726 57.9941V74.2134H191.413V59.4446C191.413 55.2909 192.897 51.7965 196.815 51.7965Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.178 75.2024C235.621 75.2024 238.293 73.9497 240.193 71.7739V74.2134H250.286V57.6645C250.286 47.5769 243.458 40.1925 233.959 40.1925C224.697 40.1925 217.631 48.1043 217.631 57.6645C217.631 67.2906 223.509 75.2024 232.178 75.2024ZM233.959 64.0599C230.574 64.0599 228.318 61.1589 228.318 57.7304C228.318 54.236 230.574 51.335 233.959 51.335C237.343 51.335 239.599 54.236 239.599 57.7304C239.599 61.1589 237.343 64.0599 233.959 64.0599Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.903 89.3778V73.3563C268.744 74.4771 270.941 75.2024 273.137 75.2024C282.578 75.2024 288.871 68.2136 288.871 57.6645C288.871 48.1043 281.806 40.2584 272.544 40.2584C263.044 40.2584 256.216 47.5769 256.216 57.6645V89.3778H266.903ZM272.544 64.0599C269.159 64.0599 266.903 61.1589 266.903 57.7304C266.903 54.236 269.159 51.4009 272.544 51.4009C275.928 51.4009 278.184 54.236 278.184 57.7304C278.184 61.1589 275.928 64.0599 272.544 64.0599Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.941 75.2024C319.203 75.2024 326.268 67.3565 326.268 57.7963C326.268 47.2472 319.975 40.2584 310.535 40.2584C308.338 40.2584 306.141 40.9837 304.301 42.1045V26.083H293.614V57.7963C293.614 67.8839 300.442 75.2024 309.941 75.2024ZM309.941 64.0599C306.557 64.0599 304.301 61.2248 304.301 57.7304C304.301 54.3019 306.557 51.4009 309.941 51.4009C313.325 51.4009 315.581 54.3019 315.581 57.7304C315.581 61.2248 313.325 64.0599 309.941 64.0599Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.151 75.2024C355.413 75.2024 362.479 67.2906 362.479 57.6645C362.479 48.1043 355.413 40.1925 346.151 40.1925C336.889 40.1925 329.824 48.1043 329.824 57.6645C329.824 67.2906 336.889 75.2024 346.151 75.2024ZM346.151 64.0599C342.767 64.0599 340.511 61.1589 340.511 57.7304C340.511 54.236 342.767 51.335 346.151 51.335C349.535 51.335 351.792 54.236 351.792 57.7304C351.792 61.1589 349.535 64.0599 346.151 64.0599Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.389 75.2024C391.651 75.2024 398.716 67.2906 398.716 57.6645C398.716 48.1043 391.651 40.1925 382.389 40.1925C373.127 40.1925 366.062 48.1043 366.062 57.6645C366.062 67.2906 373.127 75.2024 382.389 75.2024ZM382.389 64.0599C379.005 64.0599 376.749 61.1589 376.749 57.7304C376.749 54.236 379.005 51.335 382.389 51.335C385.773 51.335 388.029 54.236 388.029 57.7304C388.029 61.1589 385.773 64.0599 382.389 64.0599Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.361 74.2134V61.8841H417.499C417.677 62.3456 417.974 62.8731 418.271 63.3346L425.395 74.2134H437.923L426.523 57.5985L437.982 41.2474H425.336L418.271 51.7965C417.914 52.258 417.677 52.7855 417.439 53.313H415.361V26.083H404.674V74.2134H415.361Z",
    fill: "#FFFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.641 75.2683C460.885 75.2683 467 70.785 467 63.8621C467 51.4669 451.326 55.225 451.326 51.1372C451.326 50.1482 452.157 49.423 453.701 49.423C455.719 49.423 457.738 50.6097 458.391 52.5877L466.109 47.7087C464.388 44.0165 460.528 40.1925 453.463 40.1925C445.388 40.1925 440.639 45.2033 440.639 51.4009C440.639 64.1917 456.313 60.104 456.313 64.1258C456.313 65.1807 455.304 66.0378 453.107 66.0378C450.435 66.0378 448.832 64.9829 447.763 62.8731L440.045 67.6861C442.598 72.697 446.932 75.2683 453.641 75.2683Z",
    fill: "#FFFBFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7710_11547",
    x: 13.637,
    y: 74.5815,
    width: 99.5993,
    height: 51.6898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.63564,
    result: "effect1_foregroundBlur_7710_11547"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7710_11547",
    x: 0.835107,
    y: 0.260638,
    width: 125.434,
    height: 125.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.42553
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.58245
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7710_11547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7710_11547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_7710_11547",
    x: 41.0762,
    y: 25.4884,
    width: 45.1164,
    height: 57.8559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.01449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7710_11547"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.01449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7710_11547",
    result: "effect2_innerShadow_7710_11547"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_7710_11547",
    x: 143.136,
    y: 24.0207,
    width: 323.864,
    height: 67.4194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.06235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.06235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7710_11547"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.06235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.06235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7710_11547",
    result: "effect2_innerShadow_7710_11547"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapBooks);
export default __webpack_public_path__ + "static/media/SnapBooks.721f3fae76eebdbeba54604e306294c7.svg";
export { ForwardRef as ReactComponent };